<template>
  <div class="panelFrame">
    <div class="head flex">
      <div class="first"></div>
      <div class="items" :class="index == active && 'active'"
        v-for="(item, index) in items" :key="index"
        @click="onChange(index)">
        {{ item.label }}
      </div>
      <div class="mask" :style="{ transform: 'translateX(' + active * 8 + 'em)' }">{{ items[active].label }}</div>
      <div class="tail"></div>
    </div>
    <slot class="slot"></slot>
  </div>
</template>

<script>
export default {
  name: 'panelFrame',
  data() {
    return {
      active: 0
    }
  },
  props: {
    items: {
      type: Array,
      default: null
    }
  },

  methods: {
    onChange(index) {
      this.active = index;
      this.$emit('panelChange', index);
    },
  }
}
</script>

<style lang="scss">
.panelFrame{
  margin: 24px;
  margin-top: 48px;
  padding: 24px;
  // padding-right: 0;
  height: calc(100vh - 120px);
  width: calc(100% - 96px);
  // min-width: 900px;
  background-color: #fff;
  border-radius: 0 12px 12px;
  box-shadow: var(--main-shadow);
  position: relative;

  .head{
    position: absolute;
    left: 0;
    top: -40px;
    z-index: 0;
    .first{
      height: 40px;
      width: 12px;
      border-radius: 12px 0 0 0;
      background-color: #fff;
      z-index: -1;
    }

    .items{
      position: relative;
      height: 34px;
      width: 8em;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #fff;
      transition: 300ms;
      cursor: pointer;
      z-index: 10;
      padding-top: 6px;
      
      &::before{
        content: "";
        position: absolute;
        inset: 6px 2px 0 2px;
        z-index: 0;
        background-color: var(--main-color);
        border-radius: 8px;
        z-index: -1;
        opacity: 0;
        transition: 300ms;
      }

      &:hover, &:active {
        color: white;
        &::before{
          opacity: 0.6;
        }
      }
    }
    .mask{
      position: absolute;
      left: 12px;
      margin: 6px 2px 0 2px;
      width: calc(8em - 4px);
      height: 34px;
      border-radius: 8px;
      background-color: var(--main-color);
      transition: 200ms;
      z-index: 11;
      color: #fff;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .tail{
      height: 40px;
      width: 120px;
      overflow: hidden;
      position: relative;

      &::after{
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        height: 80px;
        width: 120px;
        border-radius: 0 120px 0 0 / 0 80px 0 0;
        background-color: #ffffff;
        z-index: -1;
      }
    }
  }

  .slot{
    z-index: 10;
    overflow-y: auto;
  }
}
</style>